import { AnyAction } from 'redux';
import { useDispatch } from 'react-redux';
import { updateFieldsForProperty } from 'modules/queryBuilder/legacyQueryBuilder/actions';
import { FieldOption } from '../types';

export const useUpdateFieldsForProperty = () => {
  const dispatch = useDispatch();

  return (property: string, fields: FieldOption[]) => {
    dispatch(updateFieldsForProperty(property, fields) as AnyAction);
  };
};
